import AppForm from '../app-components/Form/AppForm';

Vue.component('admin-user-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                first_name:  '' ,
                last_name:  '' ,
                email:  '' ,
                password:  '' ,
                activated:  false ,
                forbidden:  false ,
                language:  '' ,
                app_offices_id:  '' ,
                
            },
            office_selected: ''
        }
    },
    methods:{
        onSelect(appFactory) {
            if (appFactory !== null) {
                this.form.app_offices_id = appFactory.id;
            }else{
                this.form.app_offices_id = null;
            }
        },
        onRemove(appFactory) {
            this.form.app_offices_id = null;
        },
    },
    props: {
        appOffice: {
            type: Object,
            default: {}
        }
    },
    mounted: function () {  
        this.office_selected = this.appOffice
    }
});